import { SLIDE_LOADED } from '../actions'

const initialState = { isLoading: true, numLoaded: 0 }

const slides = (state = initialState, action) => {
  switch (action.type) {
    case SLIDE_LOADED:
      return {
        ...state,
        isLoading: action.numLoaded < 1,
        numLoaded: action.numLoaded
      }
    default:
      return state
  }
}

export default slides



// WEBPACK FOOTER //
// /opt/build/repo/src/reducers/slides.js